<template>
  <div class="comments-section">
    <div id="header">
      <h3>Discussion</h3>
    </div>
    <async-block :loading="loading">
      <comment-list></comment-list>
      <comment-editor
        class="editor"
        ref="commentEditorOverview"
        name="comment[content]"
        commentable-type="Item"
        v-if="canCreateComment"
      />
    </async-block>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CommentList from '@cmp/comments/comment_list';
import CommentEditor from '@cmp/comments/comment_editor';

export default {
  components: { CommentList, CommentEditor },
  data: function(){
    return {
      loading: true
    }
  },
  created: function(){
    const vm = this;
    vm.$store.dispatch('getItemComments', vm.item.id).then(() => vm.loading = false).catch(() => vm.loading = false);
  },
  computed: {
    ...mapState(['comments', 'item']),
    canCreateComment: function(){
      if(this.$root.userLoggedIn) {
        return true;
      }else if(this.item.attributes.allow_anonymous_comments) {
        return true;
      } else {
        return false;
      }
    }
  },
};
</script>

<style lang="scss">
@import "../../../packs/application.scss";

.comments-section {
  text-align: left;
  color: $dark-gray;
  padding: 0 40px;
}


.no_comment_section {
  background: $white;
  text-align: center;
  padding: 2rem;

  .no_comments {
    padding: 2rem;
    text-align: center;
  }

  .no_comment_heading {
    color: $warm-gray;
    padding: 0.5rem 0rem;
    font-size: 1.2rem;
  }

  .no_comment_text {
    color: $warm-gray;
    font-size: 0.7rem;
  }
}

#header {
  margin-bottom: 1rem;
}

h3 {
  font-size: 1.25rem;
}

@media (max-width: 600px) {
  .comments-section {
    text-align: left;
    padding: 0 0.5rem;
  }
}
</style>
